module.exports = __webpack_public_path__ + "static/whatisasession-2-2761779f35dcaa3c8fa1173835d080e6.svg";